import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { buildEndpointShared } from '../EndPoints';

const useCountryService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetCountries, setFetchingGetCountries] = useState(false);

    const getCountries = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: `${buildEndpointShared(`countries/countries`)}`,
            setFetching: setFetchingGetCountries
        });
    };

    return {
        fetchingGetCountries,
        getCountries
    };
};

export default useCountryService;
